import { Col, Container, Row } from "reactstrap";
import Chip from "src/components/Common/UI/Chips/Chip";
import ParametersHeader from "../ParametersHeaders";
import Areas from "./Areas/Areas";
import Cities from "./Cities/Cities";
import Places from "./Places/Places";




const Geographicals = () =>{
  
    const chipHeaders = ["Περιοχές", "Πόλεις", "Τοποθεσίες"];
    const chipItems: React.ReactNode[] = [
      <Areas />,
      <Cities />,
      <Places />,
    ];
  
    return (
      <div className="page-content">
        <ParametersHeader />
  
        <Container fluid>
          <Row>
            <Col xs={12}>
              {<Chip
                tabNavHeaderItems={chipHeaders}
                tabContentItems={chipItems}
                hasStatusCircle={false}
              />}
            </Col>
          </Row>
        </Container>
  
  
      </div>
    );
}

export default Geographicals